import PropTypes from "prop-types";
import React, { Fragment } from "react";

import EmptyState from "../../components/emptyState";
import Icon from "../interface/Icon";
import ToolbarTextButton from "../toolbar/ToolbarTextButton";
import InspectorGroup from "./InspectorGroup";
import InspectorHeader from "./InspectorHeader";

const getCollapseIcon = (onCollapseClick, showCollapseLeft, text = "Back") => {
  return onCollapseClick ? (
    showCollapseLeft ? (
      <ToolbarTextButton
        icon="leftArrow"
        text={text}
        navigateBackStyle={true}
        onClick={onCollapseClick}
        tooltip="Hide Inspector Panel"
      />
    ) : (
      <Icon
        icon="rightArrow"
        className="inspectorCollapseArrow"
        color="iconMono"
        onClick={onCollapseClick}
        tooltip="Hide Inspector Panel"
      />
    )
  ) : null;
};

const InspectorEmptyBox = props => {
  const collapseIcon = getCollapseIcon(props.onCollapseClick);
  return (
    <InspectorGroup view="inspector">
      <InspectorHeader key="title">
        {props.showCollapseLeft ? (
          <Fragment>
            {collapseIcon}
            <span>{props.title ? props.title : ""}</span>
          </Fragment>
        ) : (
          <Fragment>
            <span>{props.title ? props.title : ""}</span>
            {collapseIcon}
          </Fragment>
        )}
      </InspectorHeader>

      <div className="inspectorEmpty">
        <EmptyState svg="edit" type="sidePanel">
          <div key="content">
            <p>{props.content ? props.content : "No items selected."}</p>
          </div>
        </EmptyState>
      </div>
    </InspectorGroup>
  );
};

InspectorEmptyBox.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  onCollapseClick: PropTypes.func,
  showCollapseLeft: PropTypes.bool,
  collapseText: PropTypes.string
};

export default InspectorEmptyBox;
